module.exports = __webpack_public_path__ + "static/media/Sample_Formatting_Before.9a313353.png";